<div class="container-fluid p-5">
  <div class="row">
    <div class="col-12 col-sm-10 col-md-8 offset-sm-1 offset-md-2 jumbo">
      <form [formGroup]="signupForm" class="k-form-inline">

        <p><b>Already have an account? <a routerLink="/login" class="ulink">Sign In</a></b></p>

        <div class="form-group row">
          <div class="col-md-6 offset-md-3">
            <h3>User Details</h3>
            <p class="smalltext">Please enter your details to create an account.</p>
          </div>
        </div>

        <div class="k-form-field">
          <label for="first_name" class="form-label col-3">First name</label>
          <div class="col-8">
            <input type="text" class="form-control" formControlName="first_name" id="first_name">
            <!--            <div *ngIf="first_name?.invalid" class="alert alert-danger">-->
            <!--              <div *ngIf="first_name?.errors?.['required']">First name is required.</div>-->
            <!--            </div>-->
          </div>
        </div>

        <div class="k-form-field">
          <label for="last_name" class="form-label col-3">Last name</label>
          <div class="col-8">
            <input type="text" class="form-control" formControlName="last_name" id="last_name">
            <div *ngIf="signupForm.hasError('firstOrLastNameRequired')" class="alert alert-danger">
              <div>First name or last name is required.</div>
            </div>
            <!--            <div *ngIf="last_name?.invalid" class="alert alert-danger">-->
            <!--              <div *ngIf="last_name?.errors?.['required']">Last name is required.</div>-->
            <!--            </div>-->
          </div>
        </div>

        <div class="k-form-field">
          <label for="phone" class="form-label col-3">Phone Number</label>
          <div class="col-8">
            <input type="text" class="form-control" formControlName="phone" id="phone">
            <div *ngIf="phone?.invalid" class="alert alert-danger">
              <div *ngIf="phone?.errors?.['pattern']">Invalid Phone Number.</div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="email" class="form-label col-3 k-label">Email</label>
          <div class="col-8">
            <input type="email" id="email" formControlName="email" class="form-control"
              style="text-transform: lowercase;">
            <div *ngIf="email?.invalid" class="alert alert-danger">
              <div *ngIf="email?.errors?.['required']">Email address is required.</div>
              <div *ngIf="email?.errors && email?.errors?.['email']">Please, enter valid email address.</div>
            </div>
          </div>
        </div>
        <div class="k-form-field" #appendTo>
          <label for="password" class="form-label col-3 k-label">Password</label>
          <div class="col-8">
            <input type="password" id="password" formControlName="password" class="form-control">
            <div *ngIf="f['password'].invalid" class="alert alert-danger">
              <div *ngIf="f['password'].errors && f['password'].errors['required']">Password is required.</div>
              <div *ngIf="f['password'].errors?.['minlength']">
                Password must be at least 6 characters.
              </div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <label for="confirmPassword" class="form-label col-3 k-label">Confirm Password</label>
          <div class="col-8">
            <input type="password" id="confirmPassword" formControlName="confirmPassword" class="form-control" />

            <div *ngIf="f['confirmPassword'].invalid" class="alert alert-danger">
              <div *ngIf="f['confirmPassword'].errors?.['required']">Confirm password is required.</div>
              <div *ngIf="signupForm.errors?.['passwordMismatch']">Passwords do not match.</div>
            </div>
          </div>
        </div>

        <hr>
        <div class="k-form-field">
          <div class="col-md-8 offset-md-3">
            <input type="checkbox" kendoCheckBox formControlName="agreeToTerms"
              style="margin-top:3px; margin-right: 5px" />
            <label class="k-checkbox-label" style="margin-right: 5px">I agree to the <a
                style="text-decoration: underline;" (click)="openTerms()">Terms of use</a></label>

            <div *ngIf="agreeToTerms?.invalid" class="alert alert-danger">
              <div *ngIf="f['agreeToTerms'].errors?.['required'] || f['agreeToTerms'].errors?.['requiredTrue']">
                Please read and agree to the Terms of Use.
              </div>
            </div>
          </div>
        </div>

        <div class="k-form-field">
          <div class="col-md-8 offset-md-3">
            <input type="checkbox" kendoCheckBox formControlName="newsletter" style="margin-right: 5px" />
            <label class="k-checkbox-label" style="margin-top: -5px;">Send me news about REFLEXIS</label>
          </div>
        </div>
        <div class="k-form-field">
          <div class="col-md-8 offset-md-3">
            <input type="checkbox" kendoCheckBox formControlName="research_consent" style="margin-right: 5px" />
            <label class="k-checkbox-label" style="margin-top: -5px;">I consent that my de-identified data can be used
              for research purposes</label>
          </div>
        </div>

        @if (showCaptcha) {

        <div class="k-form-field">
          <div class="offset-3 col-9 p-2">
            <captcha-required formControlName="captchaValid" [setFocus]="focusCounter"
              (change)="captchaHandler($event)"></captcha-required>
          </div>
        </div>

        <div class="k-form-field">
          <div class="offset-3 col-5 p-2">
            @if(captchaValid?.invalid){
            <div class="alert alert-danger">

              @if(captchaValid?.errors?.['required']){
              <div>
                Captcha text required.
              </div>
              }
            </div>

            }
          </div>

        </div>

        <div class="k-form-field">
          <label class="form-label col-3 k-label"></label>
          <div class="col-8">
            <button class="btn btn-primary" type="submit" [disabled]="signupForm.invalid" (click)="onSubmit()">
              <fa-icon icon="envelope"></fa-icon> Create Account</button>
          </div>
        </div>

        }
        @else {

        <div class="k-form-field">
          <label class="form-label col-3 k-label"></label>
          <div class="col-8">
            <button class="btn btn-primary" type="submit" [disabled]="signupForm.invalid" (click)="sendClicked()">
              <fa-icon icon="envelope"></fa-icon> Sign Up</button>
          </div>
        </div>

        }

        <!-- <div class="k-form-field">
          <div class="col-md-12 offset-md-3">
            <casi-captcha formControlName="captchaValid" (change)="captchaHandler($event)"></casi-captcha>
          </div>

        </div> -->


        <!-- <div class="k-form-field">
          <label class="form-label col-3 k-label"></label>
          <div class="col-8">
            @if(busy){
            <button class="btn btn-primary" disabled="true"><fa-icon [icon]="['fat', 'spinner']"
                [spin]="true"></fa-icon> Sign Up</button>
            } @else {
            <button class="btn btn-primary" type="submit" [disabled]="signupForm.invalid" style="margin-right: 5px;"
              (click)="onSubmit()">Create Account</button>
            }
          </div>
        </div> -->

      </form>
    </div>
  </div>
</div>

<kendo-dialog *ngIf="showTermsDialog" (close)="closeTerms()" [width]="900" class="terms-dialog">
  <kendo-dialog-titlebar>Terms of Use</kendo-dialog-titlebar>

  <div class="terms-content">
    <p [innerHTML]="docContent"></p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeTerms()" class="btn btn-primary">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>
